import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

import RequestTypes from "../../enums/RequestTypes";
import EstimateStatus from "../../enums/EstimateStatus";
import Roles from "../../enums/Roles";

import Paginator from "../sub/Paginator";

import DateUtil from "../../util/DateUtil";
import Util from "../../util/Util";

import EstimateRow from "./EstimateRow";
import EstimateModal from "./EstimateModal";
import { Col, Form, FormSelect, Row } from "react-bootstrap";
import MenuButton from "../sub/bootstrap/MenuButton";
import TableToolbar from "../sub/bootstrap/TableToolbar";
import InputTextElement from "../sub/InputTextElement";
import Select from "react-select";
import ConfirmationModal from "../sub/modals/ConfirmationModal";

class Estimates extends React.Component {
  constructor(props) {
    super(props);

    this.defaultClientSelected = {
      value: "",
      label: `${this.props.intl.formatMessage({ id: "Client" })}: ${this.props.intl.formatMessage({ id: "All" })}`,
    };

    this.state = {
      modal: null,
      selectedClient: this.defaultClientSelected,
      dateFilter: "",
      statusFilter: "",
    };

    this.paginator = new Paginator(this);
  }

  openEstimateModal(request) {
    this.setState({
      modal: (
        <EstimateModal close={() => this.closeModal()} request={request} />
      ),
    });
  }

  openConfModal(title, content, onAccept) {
    this.setState({
      modal: (
        <ConfirmationModal
          title={title}
          onAccept={onAccept}
          onDecline={() => this.closeModal()}
        >
          {content}
        </ConfirmationModal>
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  setDateFilter = (date) => {
    this.setState({
      dateFilter: new Date(
        new Date(date).getFullYear(),
        new Date(date).getMonth(),
        new Date(date).getDate(),
        0,
        0,
        0,
        0,
      ),
    });
  };

  areResultsFiltered = () => {
    return (
      !Util.emptyString(this.state.selectedClient.value) ||
      !Util.emptyString(this.state.dateFilter) ||
      !Util.emptyString(this.state.statusFilter)
    );
  };

  resetSearchFields() {
    this.setState({
      selectedClient: this.defaultClientSelected,
      dateFilter: "",
      statusFilter: "",
    });
  }

  getSelectOptions() {
    const options = [];
    const clients = this.props.clients.filter((c) =>
      this.props.requests.find((r) => r.client?._id === c._id),
    );

    options.push(this.defaultClientSelected);

    for (const c of clients) {
      options.push({
        value: c._id,
        label: Util.formatFullName(c.first_name, c.name),
      });
    }
    return options;
  }

  render() {
    const isClient = this.props.user.role === Roles.CLIENT;
    const requestsLength = this.props.requests.length;

    const canManage =
      !this.props.user.supervisor_id ||
      (this.props.user.supervisor_id && this.props.user.has_write_permission);

    this.paginator.init(requestsLength);

    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    let i = 0;
    let requestRowNode = this.props.requests.map((request) => {
      if (request.request_type !== RequestTypes.ESTIMATE) return null;

      if (this.state.selectedClient && this.state.selectedClient.value !== "") {
        if (request.client?._id !== this.state.selectedClient.value)
          return null;
      }

      if (this.state.dateFilter && this.state.dateFilter !== "") {
        if (
          DateUtil.toDate(request.createdAt) !==
          DateUtil.toDate(this.state.dateFilter)
        )
          return null;
      }

      if (this.state.statusFilter && this.state.statusFilter !== "") {
        if (parseInt(request.status) !== parseInt(this.state.statusFilter))
          return null;
      }

      if (this.props.limit && ++i > this.props.limit) return null;

      if (!this.paginator.keep()) return null;

      return (
        <EstimateRow
          key={request._id}
          request={request}
          openEstimateModal={(request) => this.openEstimateModal(request)}
          openConfModal={(title, content, onAccept) =>
            this.openConfModal(title, content, onAccept)
          }
          limit={this.props.limit && true}
        />
      );
    });

    let statusFilterNode = Object.values(EstimateStatus).map((status) => {
      return (
        <option key={status} value={status}>
          {this.props.intl.formatMessage({ id: "Estimate.Status." + status })}
        </option>
      );
    });

    return (
      <React.Fragment>
        {requestsLength === 0 && (
          <TableToolbar message={<FormattedMessage id="Empty.Requests" />}>
            {!this.props.limit && canManage && (
              <MenuButton
                className="ms-auto"
                onClick={() => this.openEstimateModal()}
              >
                <FormattedMessage id="Create.Request" />
              </MenuButton>
            )}
          </TableToolbar>
        )}
        {requestsLength > 0 && (
          <React.Fragment>
            {!this.props.limit && (
              <TableToolbar>
                <Form.Group as={Row} className="align-items-center">
                  {!isClient && (
                    <Col>
                      <Select
                        className={
                          this.state.selectedClient.value && "filtered-result"
                        }
                        classNamePrefix={
                          this.state.selectedClient.value && "react-select"
                        }
                        placeholder={this.props.intl.formatMessage({
                          id: "Client",
                        })}
                        options={this.getSelectOptions()}
                        noOptionsMessage={() => (
                          <FormattedMessage id={"No.Result"} />
                        )}
                        onChange={(option) =>
                          this.setState({
                            selectedClient: option,
                          })
                        }
                        value={this.state.selectedClient}
                      />
                    </Col>
                  )}
                  <Col>
                    <InputTextElement
                      id="search_date"
                      type="date"
                      className={this.state.dateFilter && "filtered-result"}
                      onChange={(e) => {
                        this.setState({ dateFilter: e.target.value });
                      }}
                      value={this.state.dateFilter}
                      disabled={disableFormInput}
                      placeholder={this.props.intl.formatMessage({
                        id: "Date",
                      })}
                    />
                  </Col>
                  <Col>
                    <FormSelect
                      id="search_status"
                      className={this.state.statusFilter && "filtered-result"}
                      onChange={(e) => {
                        this.setState({ statusFilter: e.target.value });
                      }}
                      value={this.state.statusFilter}
                      disabled={disableFormInput}
                    >
                      <option value="">
                        <>
                          {this.props.intl.formatMessage({ id: "Status" })}
                          {": "}
                          {this.props.intl.formatMessage({ id: "All" })}
                        </>
                      </option>
                      {statusFilterNode}
                    </FormSelect>
                  </Col>
                  <Col>
                    <MenuButton
                      onClick={() => this.resetSearchFields()}
                      hover={
                        this.areResultsFiltered() &&
                        !disableFormInput && (
                          <FormattedMessage id="Remove.Filter" />
                        )
                      }
                      variant={
                        this.areResultsFiltered() ? "info" : "outline-secondary"
                      }
                      icon="filter"
                      disabled={!this.areResultsFiltered() || disableFormInput}
                    />
                  </Col>
                  {canManage && (
                    <Col className="text-end">
                      <MenuButton onClick={() => this.openEstimateModal()}>
                        <FormattedMessage id="Create.Request" />
                      </MenuButton>
                    </Col>
                  )}
                </Form.Group>
              </TableToolbar>
            )}

            <table className="table table-striped tablee4mad">
              <thead>
                <tr>
                  {!isClient && (
                    <th scope="col">
                      <FormattedMessage id="Client" />
                    </th>
                  )}
                  <th scope="col" className={isClient ? "col" : ""}>
                    <FormattedMessage id="Estimate.Request" />
                  </th>
                  <th scope="col" className="col-2">
                    <FormattedMessage id="Date" />
                  </th>
                  <th scope="col" className="col-2">
                    <FormattedMessage id="Status" />
                  </th>
                  {!this.props.limit && (
                    <th scope="col" className="col-1 text-center">
                      <FormattedMessage id="Actions" />
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>{requestRowNode}</tbody>
            </table>

            {!this.props.limit && this.paginator.render()}
          </React.Fragment>
        )}

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    requests: state.requests,
    clients: state.clients,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Estimates));
